import React, { useContext, useEffect } from "react";
import { useState } from "react";
import cfe from "../../../services/cfe";
import AppContext from "../../../container/context";
import Form from "../../../components/form";
import { Box, CircularProgress } from "@mui/material";

export default function Editar(props) {
  const [clienteId] = useState(Number(props.match.params.id));
  const { notification } = useContext(AppContext);
  const [cliente, setCliente] = useState({});
  const [viaCEP, setViaCEP] = useState(false);
  const [carregandoCEP, setCarregandoCEP] = useState(false);
  const [dadosViaCEP, setDadosViaCEP] = useState("");
  const [dadosEndereco, setDadosEndereco] = useState({});
  const history = props.history;

  useEffect(() => {
    carregarUsuario();
  }, []);

  const carregarUsuario = () => {
    cfe
      .get("admin/clientes/carregar", { id: clienteId })
      .then((cliente) => {
        const endereco = {
          CEP: cliente.enderecoCEP,
          logradouro: cliente.enderecoLogradouro,
          numero: cliente.enderecoNumero,
          complemento: cliente.enderecoComplemento,
          bairro: cliente.enderecoBairro,
          municipio: cliente.enderecoMunicipio,
          UF: cliente.enderecoUF,
        };

        setDadosEndereco(endereco);
        setCliente(cliente);
      })
      .catch((err) => notification("error", "Erro ao carregar o usuário"));
  };

  const salvar = (form) => {
    form.id = clienteId;
    cfe
      .post("admin/clientes/editar", form)
      .then((res) => {
        notification("success", "Dados cadastrais editados");
        carregarUsuario();
      })
      .catch((err) => {
        console.log(err);
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Nome inválido");
          case 2:
            return notification("error", "Email inválido");
          case 3:
            return notification("error", "CPF inválido");
          case 4:
            return notification("error", "Cliente já cadastrado");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fDados = {
    title: "Dados cadastrais",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        value: cliente.nome,
        space: 4,
        required: true,
      },
      email: {
        label: "Email",
        type: "text",
        value: cliente.email,
        space: 4,
        required: true,
      },
      CPF: {
        label: "CPF",
        type: "number",
        value: cliente.CPF,
        space: 4,
        required: true,
      },
    },
    submit: {
      label: "salvar",
      action: salvar,
    },
    history,
    close: true,
  };

  const salvarEndereco = (form) => {
    form.clienteId = clienteId;
    form.CEP = form.CEP.replace("-", "");

    cfe
      .post("admin/clientes/salvarEndereco", form)
      .then((res) => {
        notification("success", "Endereço salvo com sucesso");
        carregarUsuario();
      })
      .catch((err) => {
        console.log(err);
        notification("error", "Dados inválidos");
      });
  };

  const fEndereco = {
    title: "Endereço",
    form: {
      CEP: {
        label: "CEP",
        type: "text",
        value: dadosEndereco.CEP,
        required: true,
        space: 4,
      },
      logradouro: {
        label: "Logradouro",
        value: dadosEndereco.logradouro,
        type: "text",
        space: 8,
      },
      numero: {
        label: "Número",
        type: "number",
        value: dadosEndereco.numero,
        required: true,
        space: 4,
      },
      complemento: {
        label: "Complemento",
        value: dadosEndereco.complemento,
        type: "text",
        space: 8,
      },
      bairro: {
        label: "Bairro",
        type: "text",
        value: dadosEndereco.bairro,
        required: true,
        space: 4,
      },
      municipio: {
        label: "Município",
        value: dadosEndereco.municipio,
        type: "text",
        space: 6,
      },
      UF: {
        label: "UF",
        value: dadosEndereco.UF,
        type: "text",
        space: 2,
      },
    },
    submit: {
      label: "Salvar",
      action: salvarEndereco,
    },
    customActions: [
      {
        label: "Preencher via CEP",
        action: () => setViaCEP(true),
      },
    ],
  };

  const buscarViaCEP = (form) => {
    setDadosViaCEP(form.CEP);
    setCarregandoCEP(true);
    if (form.CEP.length !== 8)
      return notification(
        "warning",
        "CEP inválido. Verifique o dado e tente novamente."
      );

    fetch(`https://viacep.com.br/ws/${form.CEP}/json/`)
      .then((response) => response.json())
      .then((dadosCEP) => {
        setCarregandoCEP(false);

        if (dadosCEP.erro)
          return notification(
            "error",
            "CEP inválido. Verifique o dado e tente novamente."
          );
        const endereco = {
          CEP: dadosCEP.cep,
          logradouro: dadosCEP.logradouro,
          numero: "",
          complemento: "",
          bairro: dadosCEP.bairro,
          municipio: dadosCEP.localidade,
          UF: dadosCEP.uf,
        };

        setDadosEndereco(endereco);
        setViaCEP(false);
      })
      .catch((error) => {
        console.error(error);
        setCarregandoCEP(false);
        return notification("warning", "Erro ao buscar CEP");
      });
  };

  const fCEP = {
    title: "Endereço",
    form: {
      CEP: {
        label: "CEP (apenas números)",
        type: "text",
        value: dadosViaCEP,
        required: true,
      },
    },
    submit: {
      label: "carregar",
      action: buscarViaCEP,
    },
    close: {
      label: "Fechar",
      action: () => {
        setViaCEP(false);
      },
    },
  };

  return (
    <>
      <Form formData={fDados} />
      {carregandoCEP ? (
        <Box style={{ textAlign: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <>{viaCEP ? <Form formData={fCEP} /> : <Form formData={fEndereco} />}</>
      )}
    </>
  );
}
